 /**
  * Contains utilities for fetch()
  * @class FetchUtils
  */
export default class FetchUtils {
  /**
   * Converts a payload object to a FormData() object.
   * @function createFormData
   * @memberof FetchUtils
   * @param  {object} data Data object to be converted.
   * @return {FormData}        The converted FormData object.
   */
  static createFormData(data) {
    const formData = new FormData();
    // eslint-disable-next-line
    for (const key in data) {
      // eslint-disable-next-line
      if (data.hasOwnProperty(key)) {
        formData.append(key, data[key]);
      }
    }
    return formData;
  }
  static handleResponseJson(response) {
    if (!response.ok) {
      throw Error(response.statusText);
    }
    return response.json();
  }
}



// WEBPACK FOOTER //
// ./app/util/fetchUtils.js